function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { requiredValidation } from 'validators';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
export default function UnitNameTextField() {
  const {
    control
  } = useFormContext();
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "unitName",
    rules: requiredValidation('Unit name is required'),
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({
      alwaysShrinkLabel: true,
      label: "Unit name",
      "data-testid": "sb-unit-name"
    }, connectControllerToTextField(renderProps)))
  });
}